import addDays from 'date-fns/addDays';
import type { CalendarIssue, CalendarDataSourceItem, FullCalendarEvent } from '../../types.tsx';

/**
 * Convert issue data source items into FullCalendar renderable events.
 * See https://fullcalendar.io/docs/event-parsing
 */
export const issueToFullCalendarEvent = (
	issue: CalendarDataSourceItem<CalendarIssue>,
): FullCalendarEvent => ({
	title: issue.key,
	extendedProps: {
		issue,
	},
	allDay: true,
	start: issue.startdate.toLocalDate(),
	end: addDays(issue.duedate.toLocalDate(), 1), // end date is exclusive in full calendar - https://fullcalendar.io/docs/event-parsing
});
